import { isDisplayedCubicLogin } from './pr-v2-cubic-review-utils';

import { DEVIN_LOGIN } from '@/lib/inngest/functions/ensure-coding-agent-bot-seat/coding-agent-bot';

const CODEX_BOT_LOGINS = new Set([
  'codex[bot]',
  'openai-codex[bot]',
  // The login Codex's GitHub connector reviews and comments as.
  'chatgpt-codex-connector[bot]',
]);

// Friendly display label for the author of a PR comment.
//
// Maps known bot/agent GitHub logins to a recognizable name (e.g.
// "copilot-pull-request-reviewer[bot]" -> "Copilot"). Falls back to:
//  - The raw login with the trailing "[bot]" stripped, for unknown bots.
//  - The raw login unchanged, for humans.
//
// Used by sidebar and discussion surfaces that need a compact label in dim
// metadata strips. Kept here (next to the other comment-author utilities)
// rather than under `src/lib` so PR v2 UI code doesn't have to reach into a
// generic location, and `src/lib` doesn't end up importing from
// `src/app/pr-v2`.
export function getSourceLabel(userLogin: string | null): string | null {
  if (!userLogin) {
    return null;
  }

  if (isDisplayedCubicLogin(userLogin)) {
    return 'cubic';
  }

  const lower = userLogin.toLowerCase();
  if (lower.startsWith('copilot-pull-request-reviewer')) {
    return 'Copilot';
  }
  if (lower.startsWith('cursor[bot')) {
    return 'Cursor';
  }
  if (lower.startsWith('gemini-code-assist')) {
    return 'gemini';
  }
  if (CODEX_BOT_LOGINS.has(lower)) {
    return 'Codex';
  }
  if (lower.startsWith('coderabbitai')) {
    return 'CodeRabbit';
  }
  if (lower.startsWith('amazon-q-developer')) {
    return 'Amazon Q';
  }
  if (lower.startsWith('google-labs-jules')) {
    return 'Jules';
  }
  if (lower === DEVIN_LOGIN) {
    return 'Devin';
  }
  if (lower.startsWith('replit[bot')) {
    return 'Replit';
  }
  if (lower.startsWith('v0[bot')) {
    return 'v0';
  }
  if (lower.startsWith('lovable[bot')) {
    return 'Lovable';
  }
  if (lower.startsWith('continue[bot')) {
    return 'Continue';
  }

  // Generic [bot] suffix: strip it so the label reads as the bot's name only.
  const botSuffix = '[bot]';
  if (lower.endsWith(botSuffix)) {
    return userLogin.slice(0, userLogin.length - botSuffix.length);
  }

  return userLogin;
}
